/**
 * Servicio que conecta con la API las inspecciones de las incidencias
 */
InspeccionIncidenciaService.$inject = ['$resource'];

export default function InspeccionIncidenciaService($resource) {
    var urlBase = Sigo.var.path + '/api/v1' + '/incidencias' + '/:incidenciaId/inspecciones';

    return $resource(urlBase + '/:inspeccionId', {
            tareaId: '@incidenciaId',
            inspeccionId: '@inspeccionId'
        }, {
            'update': {method: 'PUT'},
            'create': {method: 'GET', url: urlBase + '/create'},
            'edit': {method: 'GET', url: urlBase + '/:inspeccionId/edit'}
        }
    );
}